import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  max-width: 100%;
  width: 100%;
  opacity: ${(props) => props.disabled && "0.8"};

  textarea {
    &:not(:placeholder-shown),
    &:focus {
      border-color: var(--second-auxiliary-color);
    }
  }
  textarea {
    &:not(:placeholder-shown),
    &:focus {
      + {
        label {
          letter-spacing: 1.5px;
          height: fit-content;
          color: var(--primary-bg-color);
          background-color: var(--second-auxiliary-color);
          transform: translate(15px, -50%);
        }
      }
    }
  }

  ::-webkit-textarea-placeholder {
    color: transparent;
  }
  :-moz-placeholder {
    color: transparent;
  }
  ::-moz-placeholder {
    color: transparent;
  }
  :-ms-textarea-placeholder {
    color: transparent;
  }
  textarea::placeholder {
    color: transparent;
  }
  textarea::-webkit-textarea-placeholder {
    color: transparent;
  }
  textarea:-moz-placeholder {
    color: transparent;
  }
  textarea::-moz-placeholder {
    color: transparent;
  }
  textarea:-ms-textarea-placeholder {
    color: transparent;
  }
  textarea::placeholder {
    color: transparent;
  }
`;

export const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  width: fit-content;
  max-width: 90%;
  align-items: center;
  color: var(--primary-font-color);
  transition: transform 0.5s;
  padding: 0 10px;
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 0.8em;
  pointer-events: none;
`;

export const Textarea = styled.textarea`
  resize: none;
  width: 100%;
  height: 120px;
  background-color: transparent;
  border-radius: 10px;
  border: 1px solid var(--second-auxiliary-color);
  outline: none;
  color: var(--primary-font-color);
  padding: 10px;
  font-size: 1em;
`;
